<template>
    <div class="houseDeposit">
      <bv-top></bv-top>

        <div style="text-align: center ;padding: 10px 10px 10px 10px">
          <van-image :src="ImgUrl" style="width: 30vw;"/>
          <div style="text-align: center;padding: 10px 10px 10px 10px">
            <span style="font-family:'微软雅黑 Bold','微软雅黑 Regular','微软雅黑', sans-serif;font-weight:700;color:#666666;width: 40vw;">签署成功</span>
          </div>
          <div style="padding: 0px 0px 10px 0px"><span style="font-family:'微软雅黑', sans-serif;font-weight:400;color:#999999;padding-right: 20px ">可点击下方按钮下载已签署的交存约定书</span></div>
          <!--           <div style="padding: 0px 0px 10px 0px"><span style="font-family:'微软雅黑', sans-serif;font-weight:400;color:#999999;padding-right: 20px ">请继续交存业务</span></div>-->
                    <div style="padding: 0px 0px 10px 0px">
                      <van-row type="flex" justify="center">
                      <van-col span="4"></van-col>
                      <van-col span="14">
                        <van-button type="primary" size="large" @click="downloadFile()">约定书下载</van-button>
                      </van-col>
                      <van-col span="4"></van-col>
                    </van-row>
                    </div>
          <!--          <div>-->
<!--            <van-row type="flex" justify="center">-->
<!--              <van-col span="4"></van-col>-->
<!--              <van-col span="14">-->
<!--                <van-button type="primary" size="large" @click="payContinue()">继续交存</van-button>-->
<!--              </van-col>-->
<!--              <van-col span="4"></van-col>-->
<!--            </van-row>-->
<!--          </div>-->
      </div>
    </div>
</template>

<script>
    import Top from '@/views/components/Top'
    import {Dialog} from "vant";
    import {downloadPdf,getDepositMessage} from '@/api/maintainFund/maintainFund'
    export default {
        name: "signSuccess",
        data() {
            return {
              depositApply:{},
              regionName: '',
              regionSearchName:'',
              regionNo: '',
              onLineDeposit: '',
              ImgUrl: require("@/assets/duihao.png"),
              depAgreeId:'',
              eSignRespose:{
                depAgreeId:String,
                houseNo:String,
                ownerName:String,
                cardNo:String
              }
            }
        },
        mounted() {
          // let eSignRespose = this.$route.query.eSignRespose;
          this.eSignRespose.depAgreeId = sessionStorage.getItem('depAgreeId');
          this.eSignRespose.houseNo = sessionStorage.getItem('houseNo');
          this.eSignRespose.ownerName = sessionStorage.getItem('ownerName');
          this.eSignRespose.cardNo = sessionStorage.getItem('cardNo');
          // var depAgreeId = JSON.parse(window.sessionStorage.getItem('depAgreeId'));
          console.log(this.eSignRespose.houseNo)
          console.log("depAgreeId========="+this.eSignRespose.depAgreeId)
          // var eSignRespose = JSON.parse(window.sessionStorage.getItem('depAgreeId'));
          // this.eSignRespose = eSignRespose
          //
          // this.depAgreeId = eSignRespose.depAgreeId
        },

        components: {
            BvTop: Top,
        },
        methods: {
          copySn(url){
            // 创建输入框元素
            const cInput = document.createElement('input')
            // 将需要复制的值赋值给输入框的value值
            cInput.value = url
            // 页面底部添加输入框
            document.body.appendChild(cInput)
            // 选中输入框
            cInput.select()
            // 执行浏览器复制命令
            document.execCommand('copy')

            this.$toast.clear();
            Dialog.confirm({
              title: '提示',
              message: '复制成功',
            }).then(() => {
              document.body.removeChild(cInput)
            }).catch(()=>{
              document.body.removeChild(cInput)
            })
            // 移除输入框
          },
          getObjectURL(file) {
            let url = null;
            if (window.createObjectURL !== undefined) {
              url = window.createObjectURL(file);
            } else if (window.webkitURL !== undefined) {
              url = window.webkitURL.createObjectURL(file);
            } else if (window.URL !== undefined) {
              url = window.URL.createObjectURL(file);
            }
            return url;
          },
          downloadPdf() {
            console.log(1111111)
            console.log(this.eSignRespose.depAgreeId)
            var data = {
              depAgreeId:this.eSignRespose.depAgreeId
            };
            downloadPdf(data).then(res => {
              let blob = new Blob([res.data]);
              let url = this.getObjectURL(blob);
              let link = document.createElement('a');
              link.style.display = 'none';
              link.href = url;
              // 获取文件名
              link.download = '交存约定书.pdf';
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href);
            });
          },


          downloadFile() {
            const link = document.createElement('a')
            link.href = this.$APP_ROOT + '/api/maintenance-fund/weixin/sigeAgreePdf/'+this.eSignRespose.depAgreeId
            link.download = this.fileName
            link.style.display = 'none'
            link.click()
            this.showPopup = false
          },
          payContinue(){
            let param = {
              houseNo: this.eSignRespose.houseNo,
              ownerName: this.eSignRespose.ownerName,
              ownerCertNo: this.eSignRespose.cardNo,
            };
            getDepositMessage(param).then(res =>{
              console.log(res.data.houseDepMobiles)
              sessionStorage.setItem('payChannels',JSON.stringify({payChannels:res.data.payChannels}));
              sessionStorage.setItem('houseDepMobiles',JSON.stringify({houseDepMobiles:res.data.houseDepMobiles}));
              this.$router.push({path: '/onlineDeposit/depositMessage',query: {label: '交存申请',houseDepMobiles: res.data.houseDepMobiles,payChannels:res.data.payChannels}})
            }).catch()
          }
        }
    }
</script>

<style lang='scss' scoped>
    .houseDeposit {
        height: 100vh;
        background: #f2f2f2;

        .btn {
            margin-top: 5%;
            border-radius: 5px;
            background-color: #2acba2 !important;
            border: 1px solid #2acba2 !important;
        }

        .footFont {
            font-weight: normal;
            font-size: 14px;
            color: #999;
        }
    }

    .regionList {
        z-index: 100;
        position: absolute;
        width: 100%;
        margin-left: 25%;
        display: inline !important;
        list-style: none;
        overflow-y: scroll;
        line-height: 2;
        border-radius: 6px;
        background: white;

    }
</style>
